import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { LocalStorageService } from '../../../app/core/services/local-storage.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
  standalone: false
})
export class CookieBannerComponent implements OnInit {
    public showCookieBanner: boolean;
    
    @ViewChild('cookieBanner')
    private cookieBanner: ElementRef;

    public ngOnInit(): void {
        //Check if they've already responded to the cookie request and send the rejection or consent
        const cookieAcceptance = LocalStorageService.getItem('cookieAcceptance');
        if(cookieAcceptance){ 
            this.showCookieBanner = false;
            window['clarity']('consentv2',{
                ad_Storage: cookieAcceptance, 
                analytics_Storage: cookieAcceptance 
            });

        } else {
            this.showCookieBanner = true;
        }
    }

  acceptCookies(): void {
    //accept cookies
    this.showCookieBanner = false;
    window['clarity']('consentv2',{
        ad_Storage: "granted", 
        analytics_Storage: "granted" 
    });
    LocalStorageService.setItem('cookieAcceptance', 'granted');
  }

  rejectCookies(): void {
    //reject cookies
    this.showCookieBanner = false;
    window['clarity']('consentv2',{
        ad_Storage: "denied", 
        analytics_Storage: "denied" 
    });
    LocalStorageService.setItem('cookieAcceptance', 'denied');
  }


  //Clicking outside the banner is considered a rejection
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if(this.cookieBanner){
        const clickedInside = this?.cookieBanner.nativeElement.contains(event.target);
        if (!clickedInside) {
            this.rejectCookies();
        }
    }
  }
}
